import React from 'react'
import Icon from '@ant-design/icons'

const NoOneWinnerSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
    <path d="M18.0002 34.6668C27.2049 34.6668 34.6668 27.2049 34.6668 18.0002C34.6668 8.79542 27.2049 1.3335 18.0002 1.3335C8.79542 1.3335 1.3335 8.79542 1.3335 18.0002C1.3335 27.2049 8.79542 34.6668 18.0002 34.6668Z" stroke="#007687" strokeWidth="2" strokeLinecap="round" />
    <path d="M11.3335 13.0837V12.917" stroke="#007687" strokeWidth="2" strokeLinecap="round" />
    <path d="M24.667 13.0837V12.917" stroke="#007687" strokeWidth="2" strokeLinecap="round" />
    <path d="M24.6668 24.667C23.8335 22.167 21.6835 19.667 18.0002 19.667C14.3168 19.667 12.1668 22.167 11.3335 24.667" stroke="#007687" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const NoOneWinnerIcon = props => <Icon component={NoOneWinnerSvg} {...props} />

export default NoOneWinnerIcon